import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
import {countWords} from './../helpers/Fields';
const $=window.$;

class PracticeNokia extends Component {
	constructor(props) {
		super(props);

        this.state={ 
          practice_nokia:[],
          practice_nokia_deatils:[],
          prctce_id:'',
          practice_name:'',
        };
		this.getLrinfo=this.getLrinfo.bind(this);
    this.switchPanel = this.switchPanel.bind(this);
	}	

  getPracticenokia() {
    let page_flag = '';
    let learnerID = Common.getUserData("id", true);
    let pinNo = Common.getUserData("pinNo", true);
    let pinID = Common.getUserData("pinID", true);
    let corporateID = Common.getUserData("corporateID", true);
    let productID = Common.getUserData("productID", true);
    let specialExpiryDate = Common.getUserData("specialExpiryDate", true);
    let practiceCorner = Common.getUserData("practiceCorner", true);
    let practiceCornerMini = Common.getUserData("practiceCornerMini", true);
    //alert(practiceCorner+'--'+practiceCornerMini);
    if(practiceCorner != false){
       page_flag = 1;
    } else if(practiceCornerMini != false){
       page_flag = 2;
    } else{

    }
//alert(page_flag);
     Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl+'practice/practice-nokia', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer ' +Common.getTokenData()
                  },
                    body: JSON.stringify({
                      learnerID:learnerID,
                      pinNo:pinNo,
                      pinID:pinID,
                      corporateID:corporateID,
                      productID:productID,
                      page_flag:page_flag
                    })
                  }).then((response) => response.json())
                 .then((responseJson) => { 
                  if(responseJson.status != 0){
                  let practice_nokia_deatils = (responseJson.practice_nokia.practice_nokia_deatils!=undefined) ? responseJson.practice_nokia.practice_nokia_deatils : '';
                  let name_list = (responseJson.practice_nokia.name_list!=undefined) ? responseJson.practice_nokia.name_list : '';
                  //alert(JSON.stringify(name_list.first_id));
                  let p_id = name_list.first_id;
                  let p_name = name_list.first_name;
                  
                    if(practice_nokia_deatils && name_list){

                      this.setState({
                      practice_nokia:responseJson.practice_nokia,
                      practice_nokia_deatils:practice_nokia_deatils,
                      prctce_id:p_id,
                      practice_name:p_name,
                      });
                    }
                  }

                  Common.reactLoader("hide");
                  Common.downTabClose();
              });
      
  }

  fnPractice(id,name){
     $('#error_comment').hide();
     $('.balance-words').hide();
     $('.typing-words').hide();
     $('#comment').val('');
     $('.allact').removeClass('active');
     $('#act'+id).addClass('active');
     $("#comment_insert").css('display','none');
     this.setState({
        prctce_id:id,
        practice_name:name,
     });
  }

  fnValidate() {
    let comment = $('#comment').val();
    let prctce_id = $('#prctce_id').val();
    let practice_name = $('#practice_name').val();    
    if(comment == '') 
    {
        $('#error_comment').html("Please enter your Comment");
        $('#error_comment').show();
        return false;
    } else {

      let learnerID = Common.getUserData("id", true);      

     Common.reactLoader("show", "Please wait...");
      $('.balance-words').hide();
     $('.typing-words').hide();
        fetch(Config.domainUrl+'practice/practice-nokia-insert', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer ' +Common.getTokenData()
                  },
                    body: JSON.stringify({
                      learnerID:learnerID,
                      comment:comment,
                      prctce_id:prctce_id,
                      practice_name:practice_name
                    })
                  }).then((response) => response.json())
                 .then((responseJson) => { 
                   let insert = (responseJson.insert!=undefined) ? responseJson.insert : '';
                   if(insert == 1){
                      $('#comment').val('');
                      $("#comment_insert").css('display','block');
                    }
                   

                  Common.reactLoader("hide");
                  Common.downTabClose();
              });

    }
 }

 
fnSelected(e){  
  $('.mainsilvercss').removeClass('selected');
  $('.ulmainsilver').css('display','none');
  $('#mainsilver'+e).addClass('selected');
  $('#ulmainsilver'+e).css('display','block');
}

fnAccordion(main,e){  
   $('.allaccordion').css('display','none');
  $('#accordion'+main).addClass('active-accordion');
  $('#ulaccordion'+main+e).css('display','block');
  

}
	componentDidMount() {
		this.getPracticenokia();
	
	}

    switchPanel(type){
     this.props.switchPanel(type);
   }

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
      let practice_nokia_deatils = null;
			if(this.state.practice_nokia_deatils!=null || this.state.practice_nokia_deatils!=undefined) {		
			 practice_nokia_deatils = this.state.practice_nokia_deatils.map((key,index)=>{
        let css_sliver ="";
        {(index==0) ? css_sliver= "silverheader mainsilvercss selected": css_sliver ="silverheader mainsilvercss"}
        return <div key={`main${index}`} > <div  id={`mainsilver${index}`} onClick={(e) =>this.fnSelected(index)} className={css_sliver}><a className="guide">
                    <span>{key['title']}</span></a>
                  </div>
                  <div  className="submenu" >
                        <section className="overview">
                          <section id="module-wise">
                            <ul id={`ulmainsilver${index}`} className="ulmainsilver" style={{display:`${index==0?'':'none'}`}}> 
                            <li id={`accordion${index}`} >
                            {key['group_name'].map((g_key,g_index)=>{
                              return <div key={`group${g_index}`} onClick={(e) =>this.fnAccordion(index,g_index)}><a>
                                      <div className="num">{g_key['sno']}</div>                          
                                      <div className="txt">{g_key['g_name']}</div>
                                    </a>
                                    <ul id={`ulaccordion${index}${g_index}`} className="allaccordion" style={{display:'none'}}>
                                    {key['practice_name'][g_index].map((p_key,p_index)=>{
                                      return <li key={`pract${p_index}`}><p><span>
                                      <a id={`act${p_key['p_id']}`} className="allact" onClick={(e) =>this.fnPractice(p_key['p_id'],p_key['p_name'])} href="javascript:void(0);">
                                                {p_key['p_name']}</a>
                                              </span></p>
                                            </li>
                                      })
                                    }
                                                                     
                                    </ul>
                                    </div>
                              })
                            }
                            </li>                
                            </ul>
                             </section>
                        </section>
                  </div>   
                  </div>
      });
    }
		return (
		  <section className="maincontent practicescore choose" >
          <div className="leftposstatic1">
            <div id="practice_left">
              <section id="leftnavsec" className="left-nav"  style={{display:'block',zIndex:1}}>
                    <div className="title-bg">
                      <h1><span><img border="0" align="absmiddle" src={process.env.PUBLIC_URL+'/images/img-lr1.png'} alt="" /></span>
                        Choose the practice</h1>
                    </div>              
                    <div className="applemenu"> 
                      <a className="link-txt" href="javascript:void(0)" onClick={e=>this.switchPanel('practice_datewise')}>Practice Score -  Datewise</a>
                      <a className="link-txt1" href="javascript:void(0)" onClick={e=>this.switchPanel('practice_score')}>Practice Score -  Practicewise</a> 
                          {practice_nokia_deatils}                              
                    </div>
              </section>
            </div>
          </div>
          <section className="contentarea">
                <h3>{this.state.practice_name}</h3>
                <ul className="valitxt">
                  <li>Please type in the action taken here.</li>
                    <li>Maximum of 100 words.</li>
                    <li>Your action will be shared with your mentor.</li>
                </ul>
                <form method='post' action="javascript:void(0);" >
                  {/* <input type='hidden' name='prctce_id' id='prctce_id' value={this.state.prctce_id} />
                  <input type='hidden' name='practice_name' id='practice_name' value={this.state.practice_name} /> */}
                    <div>
                  <textarea name='comment' id="comment" onKeyUp={(e) =>countWords(e)} data-total-words="100"></textarea>
									<div className="max-words">
										<span className="date_red lefttxt">Max words: 100</span>
									</div>
									<div className="word-count">
										<span className="balance-words"></span>
										<span className="typing-words"></span>
									</div>
                  <div id="error_comment" className="errornoTM" style={{display: 'none'}}></div>
                    <div className="button">
                  <input type="submit" value="Submit"  name='submit' onClick={(e) =>this.fnValidate()} />
                    </div>
                    <div id="comment_insert" style={{display:'none'}} className="chartstatus">Comment Saved Successfully</div>
                    </div>
                </form>
          </section> 

        </section>


			);

		}
}

export default PracticeNokia;



// WEBPACK FOOTER //
// ./src/practice/PracticeNokia.js